import { Card, Grid } from "@mui/material";
import { OutlinedBox } from "components/alove/OutlinedBox";
import { T } from "components/alove/Translator";
import { EndUser } from "models/profile/EndUser";
import { Introduction } from "models/introduction/Introduction";
import React from "react";
import { camelCaseToCapitalizedWords, tr } from "utils/globalsUtils";
import { useMaterialUIController } from "context";

const MDTypography = require("components/MDTypography/index.js").default;
const parentName = (profile, user) => {
  if (profile?.attributesValues["userType"] == "parent") {
    const parentName = user.customAttributes?.["custom:parentname"];
    if (!parentName) {
      return <T>parentNameNotSet</T>;
    }
    return (
      <MDTypography variant="body2">
        {parentName},{" "}
        <MDTypography component="span" variant="body2" style={{ fontWeight: "bold" }}>
          <T>Parent</T>
        </MDTypography>
      </MDTypography>
    );
  }
  return (
    <MDTypography variant="body2">
      {fullName(user)},{" "}
      <MDTypography component="span" variant="body2" style={{ fontWeight: "bold" }}>
        <T style={{ fontWeight: "bold" }}>Single</T>
      </MDTypography>
    </MDTypography>
  );
};
const fullName = (user: EndUser) => {
  return user?.firstName + " " + (user?.lastName || "");
};

const imagePolicy = (profile, user) => {
  const policy = profile.attributesValues?.imagePolicy?.at(0) || "onlyMM";
  return policy == "onlyMM"
    ? tr("notAllowedPhoto", { name: user.firstName })
    : tr("allowedPhoto", { name: user.firstName });
};

export const ContactDetails = ({ shRequest }: { shRequest: Introduction }) => {
  const [controller] = useMaterialUIController();
  const { mobileView } = controller;
  return (
    <Grid display="flex" style={{ textOverflow: "ellipsis" }}>
      <Grid size={6}>
        <MDTypography variant="body2" style={{ textDecoration: "underline" }}>
          {fullName(shRequest.initiatorUser)}
        </MDTypography>
        <MDTypography variant="body2">
          {parentName(shRequest.initiatorProfile, shRequest.initiatorUser)}
        </MDTypography>
        <MDTypography variant="body2">
          <a
            href={`mailto:${shRequest.initiatorUser?.email}`}
            target="blank"
            style={{ textOverflow: "ellipsis" }}
          >
            {shRequest.initiatorUser?.email}
          </a>{" "}
          {mobileView ? <br /> : " "}
          <a href={`tel:${shRequest.initiatorUser?.phoneNumber}`} target="blank">
            {shRequest.initiatorUser?.phoneNumber}
          </a>
        </MDTypography>
        <MDTypography variant="body2">
          {imagePolicy(shRequest.initiatorProfile, shRequest.initiatorUser)}
        </MDTypography>
        {shRequest.statusReasonObj?.initiatorStatus && (
          <MDTypography variant="body1" fontWeight="bold" color="secondary">
            <T>response{shRequest.statusReasonObj?.initiatorStatus}</T>
          </MDTypography>
        )}
      </Grid>
      <Grid size={6}>
        <MDTypography variant="body2" style={{ textDecoration: "underline" }}>
          {fullName(shRequest.responderUser)}
        </MDTypography>

        <MDTypography variant="body2">
          {parentName(shRequest.responderProfile, shRequest.responderUser)}
        </MDTypography>
        <MDTypography variant="body2">
          <a href={`mailto:${shRequest.responderUser?.email}`} target="blank">
            {shRequest.responderUser?.email}
          </a>{" "}
          {mobileView ? <br /> : " "}
          <a href={`tel:${shRequest.responderUser?.phoneNumber}`} target="blank">
            {shRequest.responderUser?.phoneNumber}
          </a>
        </MDTypography>
        <MDTypography variant="body2">
          {imagePolicy(shRequest.responderProfile, shRequest.responderUser)}
        </MDTypography>
        {shRequest.statusReasonObj?.responderStatus && (
          <MDTypography variant="body1" fontWeight="bold" color="secondary">
            <T>response{shRequest.statusReasonObj?.responderStatus}</T>
          </MDTypography>
        )}
      </Grid>
    </Grid>
  );
};
